<template>
  <div>
    <v-tabs v-model="tab" background-color="transparent" grow>
      <v-tab href="#tab-1">
        CARGAR HISTORIAL DE AVANCES
      </v-tab>
      <v-tab href="#tab-2">
        CARGAR HISTORIAL PAROS
      </v-tab>
      <v-tab href="#tab-3">
        CARGAR HISTORIAL SCRAP
      </v-tab>

      <v-tabs-items v-model="tab" touchless>
        <v-tab-item :key="1" :value="'tab-1'" eager>
          <v-col cols="12">
            <v-row>
              <v-col cols="4">
                <v-autocomplete v-model="dataAvances.idOrdenTrabajo" label="Orden de trabajo" :items="Tbtdboper"
                  item-value="idTrabajoOrden" item-text="clave" :loading="loadingTbtdboper" clearable />
              </v-col>

              <v-col cols="4">
                <v-autocomplete v-model="dataAvances.idDetalleOrdenTrabajo" label="Artículo" :items="trabajoOrdenesDetallesAvances"
                  item-value="idTrabajoOrdenDetalle" item-text="clave" clearable />
              </v-col>

              <v-col cols="4">
                <v-autocomplete v-model="dataAvances.idOperacion" label="Operación" :items="operacionesAvances" item-value="idOperacion"
                  item-text="articulo" clearable />
              </v-col>

              <v-col cols="4">
                <v-autocomplete v-model="dataAvances.idMaquinaInstancia" label="Máquina" :items="instancias" item-value="idMaquinaIns"
                  item-text="nombre" clearable />
              </v-col>

              <v-col cols="4">
                <v-autocomplete v-model="dataAvances.idToken" label="Token" :items="tokensExtrasMaquinaAvances" item-value="idTokenExtra"
                  :item-text="nombreToken" clearable />
              </v-col>

              <v-col cols="12">
                <div class="d-flex">
                  <v-btn color="primary" text class="ml-auto" :loading="loadingCargaDescarga"
                    @click="descargarPlantilla()">Descargar Plantilla</v-btn>
                  <v-btn color="primary" text :loading="loadingCargaDescarga" :disabled="!comprobacionFormularioAvances"
                    @click="abrirDialog()">
                    Subir Archivo
                  </v-btn>
                </div>
              </v-col>
            </v-row>

            <v-dialog v-model="dialog" width="500">
              <v-card>
                <v-col cols="12">
                  <v-card-text v-if="errorCargaMasiva" class="text-center">
                    <h3>Se ha producido un Error. Intente una vez más.</h3>
                    <v-btn depressed color="red" text @click="resetCargaMasiva">Aceptar</v-btn>
                  </v-card-text>

                  <v-card-text v-else-if="cargaCargaCompleta" class="text-center">
                    <h3 v-if="cargaLink === ''">Carga Realizada Satisfactoriamente</h3>
                    <div v-else>
                      <h3>Carga Realizada Parcialmente</h3>
                      <a :href="`/api/Articulos/ReporteCargaMasiva/${cargaLink}?access_token=${token}`" target="_blank">Archivo de Reporte</a>
                    </div>
                    <v-btn depressed color="green" text @click="resetCargaMasiva">Aceptar</v-btn>
                  </v-card-text>

                  <v-card-text v-else-if="loadingCargaMasiva" class="text-center">
                    <h3>Cargando</h3>
                    <v-progress-circular :size="75" color="green" indeterminate />
                  </v-card-text>

                  <v-card-text v-else class="text-center">
                    <v-file-input v-model="selectedAvancesFile" accept=".csv, .xls, .xlsx" @change="cambioficheroCarga($event, 'selectedAvancesFile')" counter
                      show-size clearable label="Formato xlsx en formato general (Sin formato especifico)" />

                    <v-row class="mt-4">
                      <v-col cols="12" class="py-0">
                        <v-btn block color="blue" outlined class="my-2" @click="cargaProduccionMasiva()">
                          Cargar Producción
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-col>
              </v-card>
            </v-dialog>
          </v-col>
        </v-tab-item>

        <v-tab-item :key="2" :value="'tab-2'" eager>
          <v-card-text>
            <v-row>
              <v-col cols="4">
                <v-autocomplete v-model="dataParos.idOrdenTrabajo" label="Orden de trabajo" :items="Tbtdboper"
                  item-value="idTrabajoOrden" item-text="clave" :loading="loadingTbtdboper" clearable />
              </v-col>

              <v-col cols="4">
                <v-autocomplete v-model="dataParos.idDetalleOrdenTrabajo" label="Artículo" :items="trabajoOrdenesDetallesParos"
                  item-value="idTrabajoOrdenDetalle" item-text="clave" clearable />
              </v-col>

              <v-col cols="4">
                <v-autocomplete v-model="dataParos.idOperacion" label="Operación" :items="operacionesParos" item-value="idOperacion"
                  item-text="articulo" clearable />
              </v-col>

              <v-col cols="3">
                <v-autocomplete v-model="dataParos.idMaquinaInstancia" label="Máquina" :items="instancias" item-value="idMaquinaIns"
                  item-text="nombre" clearable />
              </v-col>

              <v-col cols="3">
                <v-autocomplete v-model="dataParos.idToken" label="Token" :items="tokensExtrasMaquinaParos" item-value="idTokenExtra"
                  :item-text="nombreToken" clearable />
              </v-col>

              <v-col cols="3">
                <v-autocomplete
                  v-model="dataParos.causa"
                  :items="causas"
                  item-value="idParoTipo"
                  item-text="nombre"
                  label="Causa (opcional)"
                  hide-details
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                  v-model="dataParos.subcausa"
                  :items="subcausasFiltradasParos"
                  item-value="idSubParoTipo"
                  item-text="nombreSubParoTipo"
                  label="Subcausa (opcional)"
                  hide-details
                  clearable
                ></v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-file-input
                  v-model="selectedParosFile"
                  accept=".csv, .xls, .xlsx"
                  @change="cambioficheroCarga($event, 'selectedParosFile')"
                  counter
                  show-size
                  clearable
                  label="Formato xlsx en formato general (Sin formato especifico)"
                ></v-file-input>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-btn
                  block
                  color="blue"
                  outlined
                  class="my-2 mb-4"
                  @click="cargaMasivaPost"
                  >Cargar</v-btn
                >
              </v-col>
              <v-col cols="12" class="py-0">
                <v-btn
                  block
                  color="red"
                  outlined
                  class="my-2 mb-4"
                  @click="descargarPlantillaParosMasivos"
                  >Descargar Plantilla</v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>

        <v-tab-item :key="3" :value="'tab-3'" eager>
          <v-card-text>
            <v-row>
              <v-col cols="4">
                <v-autocomplete v-model="dataScrap.idOrdenTrabajo" label="Orden de trabajo" :items="Tbtdboper"
                  item-value="idTrabajoOrden" item-text="clave" :loading="loadingTbtdboper" clearable />
              </v-col>

              <v-col cols="4">
                <v-autocomplete v-model="dataScrap.idDetalleOrdenTrabajo" label="Artículo" :items="trabajoOrdenesDetallesScrap"
                  item-value="idTrabajoOrdenDetalle" item-text="clave" clearable />
              </v-col>

              <v-col cols="4">
                <v-autocomplete v-model="dataScrap.idOperacion" label="Operación" :items="operacionesScrap" item-value="idOperacion"
                  item-text="articulo" clearable />
              </v-col>

              <v-col cols="3">
                <v-autocomplete v-model="dataScrap.idMaquinaInstancia" label="Máquina" :items="instancias" item-value="idMaquinaIns"
                  item-text="nombre" clearable />
              </v-col>

              <v-col cols="3">
                <v-autocomplete v-model="dataScrap.idToken" label="Token" :items="tokensExtrasMaquinaScrap" item-value="idTokenExtra"
                  :item-text="nombreToken" clearable />
              </v-col>

              <v-col cols="3">
                <v-autocomplete
                  v-model="dataScrap.causa"
                  :items="causas"
                  item-value="idParoTipo"
                  item-text="nombre"
                  label="Causa (opcional)"
                  hide-details
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                  v-model="dataScrap.subcausa"
                  :items="subcausasFiltradasScrap"
                  item-value="idSubParoTipo"
                  item-text="nombreSubParoTipo"
                  label="Subcausa (opcional)"
                  hide-details
                  clearable
                ></v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-file-input
                  v-model="selectedScrapFile"
                  accept=".csv, .xls, .xlsx"
                  @change="cambioficheroCarga($event, 'selectedScrapFile')"
                  counter
                  show-size
                  clearable
                  label="Formato xlsx en formato general "
                ></v-file-input>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-btn
                  block
                  color="blue"
                  outlined
                  class="my-2 mb-4"
                  @click="cargaScrapMasiva"
                  >Cargar</v-btn
                >
              </v-col>
              <v-col cols="12" class="py-0">
                <v-btn
                  block
                  color="red"
                  outlined
                  class="my-2 mb-4"
                  @click="descargarPlantillaParosMasivos"
                  >Descargar Plantilla</v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from 'axios';
import datePicker from "@/components/DatePicker";

const createCargaData = () => ({
  idOrdenTrabajo: null,
  idDetalleOrdenTrabajo: null,
  idOperacion: null,
  idMaquinaInstancia: null,
  idToken: null,
  fecha: null,
  archivo: null,
  causa: null,
  subcausa: null
});

export default {
  components: {
    datePicker
  },
  data() {
    return {
      causas: [],
      subcausas: [],
      dialog: false,

      dataAvances: createCargaData(),
      dataParos: createCargaData(),
      dataScrap: createCargaData(),

      instancias: [],
      tokens: [],
      Tbtdboper: [],

      loadingInstancias: false,
      loadingTokens: false,
      loadingCargaDescarga: false,
      loadingTbtdboper: false,
      loadingCargaMasiva: false,

      cargaCargaCompleta: false,
      errorCargaMasiva: false,
      cargaLink: "",
      selectedAvancesFile: null,
      selectedParosFile: null,
      selectedScrapFile: null,
      tab: 0,
      ficheroActualizacion: null,
    }
  },
  watch: {
    'dataAvances.idOrdenTrabajo'() {
      this.resetOrdenDependientes(this.dataAvances);
    },
    'dataParos.idOrdenTrabajo'() {
      this.resetOrdenDependientes(this.dataParos);
    },
    'dataScrap.idOrdenTrabajo'() {
      this.resetOrdenDependientes(this.dataScrap);
    },
    'dataAvances.idDetalleOrdenTrabajo'() {
      this.dataAvances.idOperacion = null;
    },
    'dataParos.idDetalleOrdenTrabajo'() {
      this.dataParos.idOperacion = null;
    },
    'dataScrap.idDetalleOrdenTrabajo'() {
      this.dataScrap.idOperacion = null;
    },
    'dataAvances.idMaquinaInstancia'() {
      this.dataAvances.idToken = null;
    },
    'dataParos.idMaquinaInstancia'() {
      this.dataParos.idToken = null;
    },
    'dataScrap.idMaquinaInstancia'() {
      this.dataScrap.idToken = null;
    },
    'dataParos.causa'() {
      this.dataParos.subcausa = null;
    },
    'dataScrap.causa'() {
      this.dataScrap.subcausa = null;
    },
  },
  methods: {
    initialize() {
      this.getTbtdboper();
      this.getInstancias();
      this.getTokens();
      this.getCausas();
      this.getTipoSubParos();
    },
    resetOrdenDependientes(data) {
      data.idDetalleOrdenTrabajo = null;
      data.idOperacion = null;
    },
    getCausas() {
        axios
          .get("/ParoTipos/ParoTipo")
          .then(response => {
            this.causas = response.data
          })
          .catch(error => {
            console.log(error)
          })
      },
    getTipoSubParos() {
      axios
        .get("/SubParoTipos")
        .then((response) => {
          this.subcausas = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    nombreToken: (value) => `[${value.token}] - ${value.multiplicador == true ?'Virtual':'Fisico'}`,
    getTbtdboper() {
      this.loadingTbtdboper = true;
      axios
        .get("/Reportes/Tbtdboper")
        .then(response => this.Tbtdboper = response.data)
        .catch(error => console.log(error))
        .finally(() => {
          this.loadingTbtdboper = false;
        })
    },

    getInstancias() {
      this.loadingInstancias = true;
      axios
        .get("/MaquinaInstancias")
        .then(response => this.instancias = response.data)
        .catch(error => console.log(error))
        .finally(() => {
          this.loadingInstancias = false;
        })
    },
    getTokens() {
      this.loadingTokens = true;
      axios
        .get(`/MaquinaInstancias/TokensMaquinsIns`)
        .then(response => this.tokens = response.data)
        .catch(error => console.log(error))
        .finally(() => {
          this.loadingTokens = false;
        })
    },
    descargarPlantilla() {
      this.loadingCargaDescarga = true;

      const url = `/api/Reportes/PlantillaCargaMasivaAvancesProduccion?access_token=${this.token}`;
      window.open(url, '_blank');

      setTimeout(() => {
        this.loadingCargaDescarga = false;
      }, 3000);
    },
    descargarPlantillaParosMasivos() {
      this.loadingCargaDescarga = true;

      const url = `/api/Reportes/PlantillaCargaMasivaParos?access_token=${this.token}`;
      window.open(url, '_blank');

      setTimeout(() => {
        this.loadingCargaDescarga = false;
      }, 3000);
    },

    abrirDialog() {
      this.dialog = true;
    },
    cambioficheroCarga(event, fileKey) {
      const allowedTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
        'text/csv'
      ];

      if (typeof event === "undefined" || event == null) {
        this[fileKey] = null;
        return;
      }

      if (!allowedTypes.includes(event.type)) {
        this.$toast.error('Tipo de archivo no válido');
        this[fileKey] = null;
        return;
      }
      this[fileKey] = event;
    },
    cargaProduccionMasiva() {
      if (this.selectedAvancesFile != null) {
        this.loadingCargaMasiva = true;

        const formData = new FormData();
        formData.append("file", this.selectedAvancesFile);

        const data = this.dataAvances;
        const idArea = this.getIdAreaFromOperacion(data.idOperacion, this.Tbtdboper);

        const query = new URLSearchParams({
          IdTrabajoOrden: data.idOrdenTrabajo,
          IdTrabajoOrdenDetalle: data.idDetalleOrdenTrabajo,
          IdOperacion: data.idOperacion,
          IdArea: idArea,
          IdMaquinaIns: data.idMaquinaInstancia,
          IdToken: data.idToken
        }).toString();

        const url = `/Reportes/CargaMasivaAvancesProduccion?${query}`;

        axios
          .post(url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.cargaLink = response.data;
            this.cargaCargaCompleta = true;
            this.loadingCargaMasiva = false;
          })
          .catch((error) => {
            console.error(error);
            this.loadingCargaMasiva = false;
            this.errorCargaMasiva = true;
          });
      }
    },
    cargaScrapMasiva() {
      if (this.selectedScrapFile != null) {
        this.loadingCargaMasiva = true;

        const formData = new FormData();
        formData.append("file", this.selectedScrapFile);

        const data = this.dataScrap;
        const idArea = this.getIdAreaFromOperacion(data.idOperacion, this.Tbtdboper);

        const query = new URLSearchParams({
          IdTrabajoOrden: data.idOrdenTrabajo,
          IdTrabajoOrdenDetalle: data.idDetalleOrdenTrabajo,
          IdOperacion: data.idOperacion,
          IdArea: idArea,
          IdMaquinaIns: data.idMaquinaInstancia,
          IdToken: data.idToken,
          IdParoTipo: data.causa,
        }).toString();

        const url = `/Reportes/RegistrarScrapHistorial?${query}`;

        axios
          .post(url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.cargaLink = response.data;
            this.cargaCargaCompleta = true;
            this.loadingCargaMasiva = false;
          })
          .catch((error) => {
            console.error(error);
            this.loadingCargaMasiva = false;
            this.errorCargaMasiva = true;
          });
      }
    },
    resetCargaMasiva() {
      this.cargaCargaCompleta = false;
      this.loadingCargaMasiva = false;
      this.errorCargaMasiva = false;
      this.cargaLink = "";
      this.selectedAvancesFile = null;
      this.selectedParosFile = null;
      this.selectedScrapFile = null;
    },
    resetData() {
      this.dataAvances = createCargaData();
      this.dataParos = createCargaData();
      this.dataScrap = createCargaData();
    },

    getTrabajoOrdenesDetalles(data) {
      const ordenSeleccionada = this.Tbtdboper.find(
        odt => odt.idTrabajoOrden === data.idOrdenTrabajo
      );

      return ordenSeleccionada ? ordenSeleccionada.trabajoOrdenesDetalles : [];
    },
    getOperaciones(data) {
      const ordenSeleccionada = this.Tbtdboper.find(
        odt => odt.idTrabajoOrden === data.idOrdenTrabajo
      );

      if (!ordenSeleccionada) return [];

      const detalleSeleccionado = ordenSeleccionada.trabajoOrdenesDetalles.find(
        detalle => detalle.idTrabajoOrdenDetalle === data.idDetalleOrdenTrabajo
      );

      return detalleSeleccionado ? detalleSeleccionado.operaciones : [];
    },
    getTokensExtrasMaquina(data) {
      const tokens = this.tokens.find(
        m => m.idMaquinaIns === data.idMaquinaInstancia
      );
      return tokens ? tokens.tokensExtras : [];
    },
    getSubcausasFiltradas(data) {
      return data.causa
        ? this.subcausas.filter(s => s.idParoTipo === data.causa)
        : [];
    },
    getIdAreaFromOperacion(idOperacionBuscado, listaTrabajoOrdenes) {
      for (const orden of listaTrabajoOrdenes) {
        for (const detalle of orden.trabajoOrdenesDetalles) {
          for (const operacion of detalle.operaciones) {
            if (operacion.idOperacion === idOperacionBuscado) {
              return operacion.idArea;
            }
          }
        }
      }
      return null;
    },
    cargaMasivaPost() {
      if (this.selectedParosFile != null) {
        this.loadingCargaMasiva = true;
        let formData = new FormData();
        formData.append("file", this.selectedParosFile);

        const data = this.dataParos;
        const idArea = this.getIdAreaFromOperacion(data.idOperacion, this.Tbtdboper);

        const query = new URLSearchParams({
          IdTrabajoOrden: data.idOrdenTrabajo,
          IdTrabajoOrdenDetalle: data.idDetalleOrdenTrabajo,
          IdOperacion: data.idOperacion,
          IdArea: idArea,
          IdMaquinaIns: data.idMaquinaInstancia,
          IdToken: data.idToken,
          IdParoTipo: data.causa,
          /* IdSubParoTipo: data.subcausa */
        }).toString();

        const url = `/Reportes/RegistrarHistorialParos2?${query}`;

        axios
          .post(url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.cargaLink = response.data;
            this.cargaCargaCompleta = true;
            this.loadingCargaMasiva = false;
          })
          .catch((error) => {
            console.log(error);
            this.loadingCargaMasiva = false;
            this.errorCargaMasiva = true;
          });
      }
    },
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    trabajoOrdenesDetallesAvances() {
      return this.getTrabajoOrdenesDetalles(this.dataAvances);
    },
    trabajoOrdenesDetallesParos() {
      return this.getTrabajoOrdenesDetalles(this.dataParos);
    },
    trabajoOrdenesDetallesScrap() {
      return this.getTrabajoOrdenesDetalles(this.dataScrap);
    },
    operacionesAvances() {
      return this.getOperaciones(this.dataAvances);
    },
    operacionesParos() {
      return this.getOperaciones(this.dataParos);
    },
    operacionesScrap() {
      return this.getOperaciones(this.dataScrap);
    },
    tokensExtrasMaquinaAvances() {
      return this.getTokensExtrasMaquina(this.dataAvances);
    },
    tokensExtrasMaquinaParos() {
      return this.getTokensExtrasMaquina(this.dataParos);
    },
    tokensExtrasMaquinaScrap() {
      return this.getTokensExtrasMaquina(this.dataScrap);
    },
    comprobacionFormularioAvances() {
      const data = this.dataAvances;
      return data.idOrdenTrabajo && data.idDetalleOrdenTrabajo && data.idOperacion && data.idMaquinaInstancia && data.idToken;
    },
    subcausasFiltradasParos() {
      return this.getSubcausasFiltradas(this.dataParos);
    },
    subcausasFiltradasScrap() {
      return this.getSubcausasFiltradas(this.dataScrap);
    },
    nombreCausas() {
      return Object.fromEntries((this.causas || []).map(c => [c.idParoTipo, c.nombre]));
    },
    nombreSubcausas() {
      return Object.fromEntries((this.subcausas || []).map(s => [s.idSubParoTipo, s.nombreSubParoTipo]));
    },
    cambioSubcausa() {
      return Object.fromEntries((this.subcausas || []).map(s => [s.idSubParoTipo, s.idParoTipo]));
    },
  },
  mounted() {
    this.initialize();
  }
};
</script>